import { model as i18n } from '!/i18n'
import { type FormattedPriceSettings } from '@setplex/tria-api'
import { combine, createEvent, createStore, sample, type Store } from 'effector'
import { formatPriceSettings } from './lib'

export const $priceSettings = createStore<FormattedPriceSettings[] | null>(null)

export const $priceSettingsWithTranslations: Store<
  FormattedPriceSettings[] | null
> = combine(
  i18n.$t,
  $priceSettings,
  (_, priceSettings) =>
    (priceSettings?.map(formatPriceSettings) as
      | FormattedPriceSettings[]
      | null) ?? null
)

export const $selectedPriceSettings =
  createStore<FormattedPriceSettings | null>(null)

export const selectPriceSettings = createEvent<{
  priceSettings: FormattedPriceSettings
}>()

sample({
  clock: selectPriceSettings,
  fn: ({ priceSettings }) => priceSettings,
  target: $selectedPriceSettings,
})

sample({
  clock: $priceSettings,
  source: {
    t: i18n.$t,
    priceSettings: $priceSettings,
  },
  fn: ({ priceSettings }) => formatPriceSettings(priceSettings?.[0]),
  target: $selectedPriceSettings,
})
